/**
 * Farbpalette nach swisstopos Base Map.
 *
 * Nicht mehr nachempfunden, sondern aus deren Stil gezogen:
 * `ch.swisstopo.basemap_world.vt/style.json`. Wo swisstopo eine Fläche mit
 * Deckkraft auflegt, steht hier die *wirksame* Farbe - was man sieht. Der Wald
 * etwa liegt dort als kräftiges #3EA800 mit 15 % auf dem Untergrund #FDFDFE;
 * das ergibt #E0F0D8, und genau das malen wir voll deckend.
 */
export const C = {
  // Grundflächen: die Landeskarte druckt auf Weiss
  paper: '#FDFDFE',
  settlement: '#F6DBA4',
  farmland: '#D3EBC7',
  grass: '#D3EBC7',
  forest: '#3EA800',
  forestEdge: '#8AC66C',
  // swisstopo legt die Bodenbedeckung *durchsichtig* ueber die Schummerung -
  // deshalb schimmert das Gelaende durch den Wald. Die Werte sind deren
  // Deckkraft bei Zoom 14.
  forestDeckung: 0.15,
  lcDeckung: 0.25,
  farmlandDeckung: 0.06,
  parkDeckung: 0.35,
  siedlungDeckung: 0.8,
  // Dunkelste und hellste Stufe der Schummerung, aus demselben Stil.
  reliefDunkel: '#ADBCC7',
  reliefHell: '#FBFCFC',
  tree: '#4E7C3A',
  treeConifer: '#3C6630',
  scrub: '#3EA800',
  rock: '#EDEAE2',
  sand: '#EFB057',
  glacier: '#CDE8F4',

  // Wasser
  water: '#D2EEFF',
  waterEdge: '#4DA4DA',
  river: '#4DA4DA',
  waterLabel: '#2F86BC',

  // Bauten: in der Landeskarte schwarz gefuellt, ohne Trennlinie -
  // aneinandergebaute Haeuser verschmelzen dort zu einer Masse
  building: '#1E1C19',
  // Fuer die Entzerrung in 3D: reines Schwarz schluckt jede Schattierung,
  // die Baukoerper waeren eine Teergrube. Ein Hauch heller macht Licht und
  // Schatten sichtbar, ohne die Karte aufzuhellen.
  building3d: '#2A2724',

  // Strassen – Werte aus den swisstopo-Kartenkacheln ausgemessen:
  // Autobahn kräftiges Amber mit dunkelbraunem Rand, Hauptstrasse lachsrosa,
  // Nebenstrasse blassgelb, Quartierstrasse weiss mit dunklem Rand
  motorway: '#F8CF75',
  motorwayCase: '#46371E',
  trunk: '#F8CF75',
  trunkCase: '#46371E',
  primary: '#FAB69E',
  primaryCase: '#4B3719',
  secondary: '#FAF39E',
  secondaryCase: '#414119',
  tertiary: '#FFFFFF',
  tertiaryCase: '#3C3C3C',
  minor: '#FFFFFF',
  minorCase: '#3C3C3C',
  service: '#FFFFFF',
  serviceCase: '#3C3C3C',
  track: '#4B4B4B',
  path: '#3C3C3C',
  rail: '#CB4D4D',
  railLight: '#D47878',
  aeroway: '#EDEAE2',

  // Höhenlinien
  contour: '#D7B384',
  contourMain: '#B46E0D',
  contourLabel: '#AB7E40',

  // Wanderwege (Landeskarte: rot gestrichelt)
  // In der Landeskarte sind Fuss- und Wanderwege duenne *schwarze* Linien.
  // Das rot Gestrichelte gehoert zur separaten Wanderkarte, nicht zur
  // Basiskarte - am gedruckten Blatt geprueft.
  hiking: '#2A2724',
  // Bahnhofsnamen im Bahnrot - so haelt es die gedruckte Landeskarte, deren
  // Bild dieser Modus nachzeichnet. Die Leichte Basiskarte von swisstopo
  // schreibt sie dagegen dunkelblau; das steht unten in der Palette "hell",
  // die genau jenem Produkt entspricht.
  stationLabel: '#C81818',

  // Grenzen. In der Landeskarte ist die Landesgrenze keine violette Linie,
  // sondern ein schmaler Strich mit breitem rosa Saum daneben - Saumfarbe aus
  // einer echten Kachel gemessen (#DEA2C0), Strichfarbe wie in swisstopos
  // eigenen Vektorkacheln.
  borderCountry: '#C35591',
  borderBand: '#DEA2C0',
  // Gleiche Farbe wie die Landesgrenze: swisstopo unterscheidet Kanton und
  // Land nicht ueber Farbe oder Strichelung, sondern nur ueber die Breite.
  // Gestrichelt ist dort nur, was umstritten oder Bezirks-/Gemeindeebene ist.
  borderCanton: '#C35591',

  // Schrift
  ink: '#1A1915',
  inkSoft: '#56524A',
  // Hausnummern stehen bei swisstopo in einem neutralen Mittelgrau
  houseNumber: '#464646',
  // Kein harter weisser Rand: swisstopo legt in den eigenen Vektorkacheln
  // einen schmalen, weichen Schleier unter die Schrift - 242er Grau bei 90%,
  // damit sie auch ueber schwarzen Gebaeudebloecken lesbar bleibt, ohne
  // aufgeklebt zu wirken. Gewaesser und Hoehenlinien bekommen den Schleier
  // im eigenen Ton, sonst sitzt ein grauer Fleck im Blau.
  halo: 'rgba(242, 242, 242, 0.9)',
  haloWater: 'rgba(220, 241, 254, 0.9)',
  haloContour: 'rgba(238, 238, 238, 0.9)',
  haloFactor: 1,
  peak: '#5A4F3E',

  // POI-Beschriftung. swisstopo faerbt nicht alles ein: der Normalfall ist
  // fast schwarz, Farbe tragen nur bestimmte Gruppen. Die Werte sind aus
  // deren Vektorstil uebernommen.
  poi: '#202020',
  poiVerkehr: '#222769',
  poiHistorisch: '#88550D',
  poiNatur: '#467927',
  poiAmtlich: '#2E3446',
  poiWasser: '#0B69A4',
  poiHuette: '#B17B08',
  poiBildung: '#056452',
  favorite: '#141414'
};

// Source Sans 3: humanistische Grotesk in der Tradition von Frutiger/Univers,
// OFL-lizenziert. Glyphen erzeugt tools/build-glyphs.mjs, ausgeliefert unter /fonts/.
// Genau ein Name je Stapel: unsere Glyphen liegen als statische Dateien, und
// ein Verzeichnis "A,B" gibt es dort nicht - Rueckfallschriften koennte nur ein
// Glyph-Server zusammensetzen.
/**
 * Schwarzweiss-Variante. Bewusst von Hand gesetzt statt gerechnet: eine reine
 * Entsättigung macht Lachsrosa und Gelb zum selben Grau. Hier trägt stattdessen
 * die Helligkeit die Hierarchie, wie auf der grauen Landeskarte.
 */
export const GREY = {
  paper: '#FFFFFF',
  settlement: '#C9C9C9',
  farmland: '#D8D8D8',
  grass: '#D8D8D8',
  forest: '#8E8E8E',
  forestEdge: '#C2C2C2',
  forestDeckung: 0.15,
  lcDeckung: 0.25,
  farmlandDeckung: 0.06,
  parkDeckung: 0.35,
  siedlungDeckung: 0.8,
  reliefDunkel: '#BFBFBF',
  reliefHell: '#FCFCFC',
  tree: '#7E7E7E',
  treeConifer: '#616161',
  scrub: '#E7E7E7',
  rock: '#E9E9E9',
  sand: '#F1F1F1',
  glacier: '#F6F6F6',

  water: '#E3E3E3',
  waterEdge: '#8C8C8C',
  river: '#9C9C9C',
  waterLabel: '#6B6B6B',

  building: '#1A1A1A',
  building3d: '#2E2E2E',

  motorway: '#C6C6C6',
  motorwayCase: '#3A3A3A',
  trunk: '#D2D2D2',
  trunkCase: '#4C4C4C',
  primary: '#DADADA',
  primaryCase: '#585858',
  secondary: '#E6E6E6',
  secondaryCase: '#6C6C6C',
  tertiary: '#FFFFFF',
  tertiaryCase: '#7E7E7E',
  minor: '#FFFFFF',
  minorCase: '#8C8C8C',
  service: '#FFFFFF',
  serviceCase: '#A4A4A4',
  track: '#4A4A4A',
  path: '#6E6E6E',
  rail: '#262626',
  railLight: '#5C5C5C',
  aeroway: '#E9E9E9',

  contour: '#C0C0C0',
  contourMain: '#949494',
  contourLabel: '#6E6E6E',

  hiking: '#3A3A3A',
  stationLabel: '#4A4A4A',

  borderCountry: '#8E8E8E',
  borderBand: '#CFCFCF',
  borderCanton: '#AFAFAF',

  ink: '#1A1A1A',
  inkSoft: '#5A5A5A',
  houseNumber: '#4A4A4A',
  halo: 'rgba(242, 242, 242, 0.9)',
  haloWater: 'rgba(236, 236, 236, 0.9)',
  haloContour: 'rgba(238, 238, 238, 0.9)',
  haloFactor: 1,
  peak: '#4A4A4A',

  poi: '#3A3A3A',
  poiVerkehr: '#4A4A4A',
  poiHistorisch: '#555555',
  poiNatur: '#4A4A4A',
  poiAmtlich: '#404040',
  poiWasser: '#525252',
  poiHuette: '#5A5A5A',
  poiBildung: '#454545',
  favorite: '#141414'
};


/**
 * "Classic": das Kartenbild, wie es vor dem Abgleich mit swisstopos Base Map
 * war - nach den gedruckten Landeskartenblaettern nachempfunden, mit deckender
 * Bodenbedeckung und kraeftigeren Strassenfarben. Bleibt erhalten, weil es ein
 * eigenes Bild ist und nicht bloss ein aelterer Stand.
 */
export const CLASSIC = {
  ...C,
  paper: '#FFFFFF',
  settlement: '#E4E1D8',
  farmland: '#FBFBF6',
  grass: '#E9F1DB',
  forest: '#CFE5B4',
  forestEdge: '#B4D199',
  scrub: '#E3EFCF',
  rock: '#EDEAE2',
  sand: '#F7F0DC',
  glacier: '#EAF6FB',

  // Deckend wie frueher - die Schummerung schimmert hier nicht durch.
  forestDeckung: 1,
  lcDeckung: 1,
  farmlandDeckung: 1,
  parkDeckung: 0.45,
  siedlungDeckung: 1,
  reliefDunkel: '#ADBCC7',
  reliefHell: '#FBFCFC',

  water: '#C3E2F2',
  waterEdge: '#4D9BC4',
  river: '#5AA8CE',
  waterLabel: '#2D7FA6',

  motorway: '#F8B838',
  motorwayCase: '#6B4A08',
  trunk: '#F8C038',
  trunkCase: '#7A5610',
  primary: '#F2A892',
  primaryCase: '#B5674E',
  secondary: '#F8D86A',
  secondaryCase: '#9A7A28',
  tertiary: '#FFFFFF',
  tertiaryCase: '#7D7668',
  minor: '#FFFFFF',
  minorCase: '#6E685C',
  service: '#FFFFFF',
  serviceCase: '#9A9488',
  track: '#4A463E',
  path: '#6B655A',
  rail: '#C81818',
  railLight: '#D04038',

  contour: '#C79A6B',
  contourMain: '#A8703C',
  contourLabel: '#8A5E30'
};

/**
 * Umschaltbare Paletten des Kartenbilds. Auf dem Luftbild ist die Vorlage
 * ein Foto statt einer Kartengrundlage - dort traegt die Schrift doch einen
 * Halo, sonst verschwindet sie in dunklen Waeldern und Schattenhaengen.
 */
export const PALETTES = {
  farbig: C,
  classic: CLASSIC,
  /**
   * "Hell": dieselbe Landeskarte, aber mit grauen Gebaeuden statt schwarzen.
   * swisstopo fuehrt neben der Landeskarte genau dafuer die Leichte Basiskarte
   * (Gebaeude hsl(220,10%,82%)) - weil automatisch gesetzte Beschriftung auf
   * schwarzen Bloecken nicht lesbar ist. Die gedruckte Karte loest das durch
   * Platzierung von Hand, was eine Webkarte nicht kann.
   */
  /**
   * "Hell": die Werte der Leichten Basiskarte, aus
   * `ch.swisstopo.lightbasemap_world.vt/style.json` gezogen.
   *
   * Die ist bewusst blasser als die Base Map und faerbt nur, was die
   * Orientierung traegt: Autobahnen gelb, Bahn rot, alles andere weiss mit
   * grauem Rand. Gebaeude sind dort hellgrau (hsl(220,10%,82%)), weil
   * automatisch gesetzte Beschriftung auf schwarzen Bloecken nicht lesbar
   * ist - die gedruckte Karte loest das durch Platzierung von Hand, was eine
   * Webkarte nicht kann.
   */
  hell: {
    ...C,
    paper: '#FCFCFC',
    settlement: '#D7E0D1',
    farmland: '#D7E0D1',
    grass: '#D7E0D1',
    forest: '#BAD2AC',
    forestEdge: '#BAC7AC',
    scrub: '#BAD2AC',
    rock: '#D7E0D1',
    sand: '#F0DABC',
    glacier: '#CDE8F4',
    forestDeckung: 0.3,
    lcDeckung: 0.3,
    farmlandDeckung: 0.08,
    parkDeckung: 0.3,
    siedlungDeckung: 0.3,
    // Die Leichte Basiskarte schummert deutlich zarter als die Base Map.
    reliefDunkel: '#C8D2D5',
    reliefHell: '#FCFCFC',

    water: '#C7E0F5',
    waterEdge: '#85BDE0',
    river: '#8AC3E5',
    waterLabel: '#2F86BC',

    building: '#CDD0D6',
    buildingEdge: '#A2A8B3',
    building3d: '#B9BDC6',

    // Nur Autobahn und Hauptachse tragen Farbe; der Rest lebt vom Rand.
    motorway: '#FFE08A',
    motorwayCase: '#8B6B3F',
    trunk: '#FFE08A',
    trunkCase: '#8B6B3F',
    primary: '#FFFFFF',
    primaryCase: '#5A5A5A',
    secondary: '#FFFFFF',
    secondaryCase: '#5A5A5A',
    tertiary: '#FFFFFF',
    tertiaryCase: '#5A5A5A',
    minor: '#FFFFFF',
    minorCase: '#5A5A5A',
    service: '#FFFFFF',
    serviceCase: '#737373',
    track: '#737373',
    path: '#737373',
    rail: '#CB4D4D',
    railLight: '#D88A8A',

    contour: '#D9BE94',
    contourMain: '#BF8A40',
    contourLabel: '#B3884D',

    borderCountry: '#E8B0E8',
    borderBand: '#E8C9E0',
    borderCanton: '#E8C9E0',

    // Dunkelblau wie in swisstopos Leichter Basiskarte gemessen.
    stationLabel: '#222769',
    haloFactor: 1
  },
  sw: GREY,
  luftbild: {
    ...C,
    halo: 'rgba(255, 255, 255, 0.95)',
    haloWater: 'rgba(255, 255, 255, 0.95)',
    haloContour: 'rgba(255, 255, 255, 0.95)',
    haloFactor: 1.8
  }
};

/**
 * Roboto Condensed, aufgeteilt wie swisstopo ihre Frutiger-Schnitte verteilt:
 * Condensed Regular als Arbeitstier (Strassen, POI, Grenzen), Condensed Medium
 * fuer Ortsnamen, und die ganze Gelaendesprache - Hoehenkurven, Hoehenkoten,
 * Flurnamen, Gewaesser - kursiv. Schmal ist hier kein Geschmack, sondern
 * Platzgewinn auf einer dichten Karte, und Medium traegt die Ortsnamen auch
 * ueber schwarzen Gebaeudebloecken.
 *
 * Je Stapel genau ein Name: bei statisch ausgelieferten Glyphen fragt MapLibre
 * sonst ein Verzeichnis "A,B" an, das es nicht gibt.
 */
export const FONT = ['Roboto Condensed Regular'];
export const FONT_MEDIUM = ['Roboto Condensed Medium'];
export const FONT_BOLD = ['Roboto Condensed Bold'];
export const FONT_ITALIC = ['Roboto Condensed Italic'];
